// Force redirect for IPv6 local issues to avoid 'frame-ancestors' errors with [::1]
if (import.meta.env.DEV && (window.location.hostname === '[::1]' || window.location.hostname === 'localhost')) {
  const newUrl = window.location.href.replace(window.location.hostname, '127.0.0.1');
  if (window.location.href !== newUrl) {
    window.location.replace(newUrl);
  }
}

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import './index.css' // Triggers globals import
import App from './App.tsx'
import { ThemeProvider } from './design-system/context/ThemeContext'
import { queryClient } from './lib/queryClient'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <App />
        <Toaster richColors position="top-right" />
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
)
